import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import icons from "../../assets/img/onoff.svg";
import messageService from "../../services/message/messageService";
import UseCommonService from "../../services/commonService/commonService";
import { useLocation } from "react-router-dom";
import { Box, CircleGauge, Users, Handshake, LogOut, Settings, UserRoundCog, Layers, Truck, Briefcase } from "lucide-react";
import TooltipSidebar from "../UIElement/TooltipSidebar";

interface SidebarProps {
  isExpanded: boolean;
  handleToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isExpanded, handleToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const commonService = UseCommonService();


  const leftsideStyle = {
    width: isExpanded ? "228px" : "73px",
    transition: "width 0.1s ease",
  };

  const mainlogoStyle = {
    width: isExpanded ? "228px" : "73px",
    transition: "width 0.1s ease",
  };

  let logout = () => {
    const messageServices = messageService();

    messageServices.confirm(`Logout`, "").then(async (res) => {
      if (res.isConfirmed) {
        const token = commonService.getToken();

        localStorage.setItem("term&&privacy", token);

        localStorage.removeItem("Smartpath_token");
        navigate("/Login");
      }
    });
  };

  const checkActive = (path: string) => {
    return location.pathname === path ? "active" : "";
  };
  const checkActive1 = (paths: string[]) => {
    return paths.some((path) => location.pathname.startsWith(path))
      ? "active"
      : "";
  };

  return (
    <>
      <div className="leftside" style={leftsideStyle}>
        <div className="sidebar flex flex-col h-full  justify-between">
          <div>


            <div className="mainlogo" style={mainlogoStyle}>
              {isExpanded ? (
                <h1 style={{ width: "100%" }} className="logo-name">
                  <span className="sptms-logo">TMS Admin</span>
                </h1>
              ) : (
                <h1 className="logo-name">
                  <span className="sptms-logo vvvvvv">A</span>
                </h1>
              )}

              {isExpanded ? (
                <img
                  onClick={handleToggle}
                  id="toggleButton bbbbbhhhh"
                  src={icons}
                  alt="Toggle Icon Round"
                />
              ) : (
                <img
                  onClick={handleToggle}
                  id="toggleButton"
                  src={icons}
                  alt="Toggle Icon"
                />
              )}
            </div>

            <ul className="under-list !pt-0">

              <Link to="/dashboard">
                <li className={`sidebar-list pl-3 ${checkActive("/dashboard")}`}>
                  <div className="flex gap-2 items-center ">
                    <CircleGauge className={` dashboard-ic  fill-[#a1a1aa]   `}

                      strokeWidth={1.5}

                      size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                      Dashboard
                    </span>
                  </div>
                </li>
              </Link>


              {/* <Link to="/pipeline/sales">
                <li className={`sidebar-list pl-3 ${["/pipeline/sales","/pipeline/new","/pipeline/inprogress","/pipeline/closed","/pipeline/deleted"].includes(location.pathname) && "active"}`}>
                  <div className="flex gap-2 items-center ">
                    <Box className={`dashboard-ic  fill-[#a1a1aa]  `}

                      strokeWidth={1.5}

                      size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                    Sales
                    </span>
                  </div>
                </li>
              </Link>

              <Link to="/students/newstudent">
                <li className={`sidebar-list pl-3 ${checkActive("/students/newstudent")}`}>
                  <div className="flex gap-2 items-center">
                    <Users strokeWidth={1.5} className={`dashboard-ic  fill-[#a1a1aa]`} size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                      Students
                    </span>
                  </div>
                </li>
              </Link>

              <Link to="/Users">
                <li className={`sidebar-list ${checkActive("/Users")}`}>
                  <img
                    src={require("../../assets/img/presention-chart.png")}
                    className="dashboard-ic"
                    alt="tms-users"
                  />
                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    TMS Users
                  </span>
                </li>
              </Link>

              <Link to="/candidate/newcandidate">
                <li className={`sidebar-list pl-3 ${checkActive("/candidate/newcandidate")}`}>
                  <div className="flex gap-2 items-center">
                    <Users strokeWidth={1.5} className={`dashboard-ic  fill-[#a1a1aa]  `} size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                      Candidates
                    </span>
                  </div>
                </li>
              </Link>

              <Link to="/bizpartners/newbizpartners">
                <li className={`sidebar-list pl-3 ${checkActive("/bizpartners/newbizpartners")}`}>
                  <div className="flex gap-2 items-center">
                    <Handshake className={` dashboard-ic ${checkActive("/bizpartners/newbizpartners") ? "text-white " : "text-zinc-400 "}`} size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                      Biz Partners
                    </span>
                  </div>
                </li>
              </Link>

              */}


              {/* <Link to="/MarketResearch">
                <li
                  className={`sidebar-list ${checkActive1(["/MarketResearch"])}`}
                >
                  <img
                    src={require("../../assets/img/assets.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span
                    style={{
                      display: isExpanded ? "block" : "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Market Research
                  </span>
                </li>
              </Link> */}

              {/* <Link to="/MarketNewRelease">
                <li
                  className={`sidebar-list ${checkActive1([
                    "/MarketNewRelease",
                  ])}`}
                >
                  <img
                    src={require("../../assets/img/dispatched.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    New Release
                  </span>
                </li>
              </Link> */}
              {/* <Link to="/accounting/ar">
                <li className={`sidebar-list pl-3 ${checkActive("/accounting/ar")}`}>
                  <div className="flex gap-2 items-center">
                    <Box className={`dashboard-ic ${checkActive("/accounting/ar") ? "text-white " : "text-zinc-400 "}`} size={20} />
                    <span style={{ display: isExpanded ? "block" : "none" }}>
                      Accounting
                    </span>
                  </div>
                </li>
              </Link>

              <Link to="/IFTA">

                <li className={`sidebar-list  ${checkActive("/IFTA")}`}>
                  <img
                    src={require("../../assets/img/clipboard-text.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    IFTA
                  </span>
                </li>
              </Link>

              <Link to="/policies/plans">
                <li className={`sidebar-list ${checkActive("/policies/plans")}`}>
                  <img
                    src={require("../../assets/img/reports.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    Policies Plans
                  </span>
                </li>
              </Link> */}

              {/* <Link to="/privacypolicy">
                <li className={`sidebar-list ${checkActive("/privacypolicy")}`}>
                  <img
                    src={require("../../assets/img/reports.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    Privacy Policy
                  </span>
                </li>
              </Link>
              <Link to="/Terms">
                <li className={`sidebar-list ${checkActive("/Terms")}`}>
                  <img
                    src={require("../../assets/img/clipboard-text.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    Terms Conditions
                  </span>
                </li>
              </Link> */}
              <Link to="/Business">
                <li className={`sidebar-list ${checkActive("/Business")}`}>
                  <img
                    src={require("../../assets/img/business-book.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    Business Book
                  </span>
                </li>
              </Link>

              <Link to="marketing">
                <li
                  className={`sidebar-list ${checkActive1(["/marketing"])}`}
                >
                  <img
                    src={require("../../assets/img/assets.png")}
                    className="dashboard-ic"
                    alt=""
                  />

                  <span
                    style={{
                      display: isExpanded ? "block" : "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Marketing
                  </span>
                </li>
              </Link>

                <Link to="/trail-users">
                  <li
                    className={`
      ${isExpanded ? "sidebar-list " : "group relative"}
      ${isExpanded && checkActive("/trail-users") ? "active" : ""}
    `}
                  >
                    <div className="flex items-center">
                      {/* ICON WRAPPER */}
                      <div
                        className={`
          flex items-center justify-center
          w-10 h-10 rounded-[10px] transition-colors
          ${!isExpanded && checkActive("/trail-users")
                            ? "bg-customOrange text-white"
                            : !isExpanded
                              ? "hover:bg-customOrange text-white/40"
                              : ""
                          }
        `}
                      >
                        <Users
                          size={20}
                          strokeWidth={1.8}
                          className="mx-2 w-5 h-5 flex-none object-scale-down transition-all text-white/80 hover:text-white "
                        />
                      </div>

                      {/* Label only visible when expanded */}
                      {isExpanded && (
                        <span>
                          TMS Users
                        </span>
                      )}
                    </div>
                    <TooltipSidebar text="TMS Users" position="-top-7 left-[105%] -translate-x-[4rem]" />
                  </li>
                </Link>

                <Link to="/job-openings">
                  <li
                    className={`
      ${isExpanded ? "sidebar-list " : "group relative"}
      ${isExpanded && checkActive("/job-openings") ? "active" : ""}
    `}
                  >
                    <div className="flex items-center">
                      {/* ICON WRAPPER */}
                      <div
                        className={`
          flex items-center justify-center
          w-10 h-10 rounded-[10px] transition-colors
          ${!isExpanded && checkActive("/job-openings")
                            ? "bg-customOrange text-white"
                            : !isExpanded
                              ? "hover:bg-customOrange text-white/40"
                              : ""
                          }
        `}
                      >
                        <Briefcase
                          size={20}
                          strokeWidth={1.8}
                          className="mx-2 w-5 h-5 flex-none object-scale-down transition-all text-white/80 hover:text-white "
                        />
                      </div>

                      {/* Label only visible when expanded */}
                      {isExpanded && (
                        <span >
                          Jobs
                        </span>
                      )}
                    </div>
                    <TooltipSidebar text="Jobs" position="-top-7 left-[105%] -translate-x-[4rem]" />
                  </li>
                </Link>

                <Link to="/tms">
                  <li
                    className={`
      ${isExpanded ? "sidebar-list " : "group relative"}
      ${isExpanded && checkActive("/tms") ? "active" : ""}
    `}
                  >
                    <div className="flex items-center">
                      {/* ICON WRAPPER */}
                      <div
                        className={`
          flex items-center justify-center
          w-10 h-10 rounded-[10px] transition-colors
          ${!isExpanded && checkActive("/tms")
                            ? "bg-customOrange text-white"
                            : !isExpanded
                              ? "hover:bg-customOrange text-white/40"
                              : ""
                          }
        `}
                      >
                        <Settings
                          size={20}
                          strokeWidth={1.8}
                          className="mx-2 w-5 h-5 flex-none object-scale-down transition-all text-white/80 hover:text-white "
                        />
                      </div>

                      {/* Label only visible when expanded */}
                      {isExpanded && (
                        <span >
                        Settings
                        </span>
                      )}
                    </div>
                    <TooltipSidebar text="Settings" position="-top-7 left-[105%] -translate-x-[4rem]" />
                  </li>
                </Link>


            
              {/* <Link to="/Plan">
                <li className={`sidebar-list ${checkActive("/Plan")}`}>
                  <div className=" group inline-block">

                    <img
                      src={require("../../assets/img/archive-bo.png")}
                      className="dashboard-ic"
                      alt=""
                    />

                  </div>
                  <span style={{ display: isExpanded ? "block" : "none" }}>
                    Billing Plan
                  </span>


                </li>
              </Link> */}


            </ul>
          </div>
          <div >
            <nav className="justify-evenly border-b-2 border-zinc-700">
              <ul className="font-sans font-medium text-gray-300 space-y-3 ">
                <li className={`sidebar-list pl-3 ${checkActive("/myprofile")}`}>
                  <Link className="w-full" to="/myprofile">
                    <div className="flex gap-2 items-center">

                      <UserRoundCog className={`dashboard-ic`} size={20} />

                      <span style={{ display: isExpanded ? "block" : "none" }}>
                        My Profile
                      </span>
                    </div>
                  </Link>
                </li>

              </ul>
            </nav>

            {/* ✅ Logout Button */}
            <button
              onClick={logout}
              className="my-5 flex items-center space-x-2 bg-red-500 hover:bg-red-700 hover:font-semibold  text-white p-2  w-full rounded-xl transition-all duration-300 ease-in-outt"
            >
              <LogOut size={20} />
              <span className="!text-white" style={{ display: isExpanded ? "block" : "none", color: "#BABABA" }}>
                Logout
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
